import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
} from '@tanstack/react-router'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
export const Route = createFileRoute('/_auth/settings/multi-channels')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const location = useLocation()

  const currentTab = location.pathname.match(
    /\/settings\/multi-channels\/([^/]+)/,
  )?.[1]

  const handleChange = (value) => {
    navigate({
      to: `/settings/multi-channels/${value}`,
    })
  }
  return (
    <div className="flex h-full w-full flex-col gap-3 overflow-hidden">
      <Tabs
        value={currentTab || 'livechat'}
        onValueChange={handleChange}
        className="w-full"
      >
        <TabsList className="mb-2">
          <TabsTrigger value="livechat">LiveChat</TabsTrigger>
          <TabsTrigger value="email">Email</TabsTrigger>
          <TabsTrigger value="facebook">Facebook</TabsTrigger>
          <TabsTrigger value="zalo">Zalo</TabsTrigger>
          <TabsTrigger value="sms">SMS</TabsTrigger>
          <TabsTrigger value="whatsapp">WhatsApp</TabsTrigger>
          <TabsTrigger value="zalo-user">Zalo cá nhân</TabsTrigger>
        </TabsList>
      </Tabs>
      <Outlet />
    </div>
  )
}
